import { lazy } from "react"

/** Lazy route targets — split from main bundle (CRA code splitting). */

export const LazyStores = lazy(() =>
	import(/* webpackChunkName: "route-stores" */ "containers/Stores/Stores")
)
export const LazyAddStore = lazy(() =>
	import(/* webpackChunkName: "route-add-store" */ "containers/Stores/AddStore")
)
export const LazyReports = lazy(() =>
	import(/* webpackChunkName: "route-reports" */ "containers/Reports/ReportsNew")
)
export const LazyVATReturns = lazy(() =>
	import(/* webpackChunkName: "route-vat-returns" */ "containers/VATReturns/VATReturnsMain")
)
export const LazyCreateReturn = lazy(() =>
	import(/* webpackChunkName: "route-create-return" */ "containers/VATReturns/CreateReturn")
)
export const LazySalesTaxReturns = lazy(() =>
	import(/* webpackChunkName: "route-sales-tax-returns" */ "containers/SalesTaxReturns/SalesTaxReturnsMain")
)
export const LazyCreateTaxReturn = lazy(() =>
	import(/* webpackChunkName: "route-create-tax-return" */ "containers/SalesTaxReturns/CreateTaxReturnMain")
)
export const LazyTransactions = lazy(() =>
	import(/* webpackChunkName: "route-transactions" */ "containers/Transactions")
)
export const LazyAddTransactions = lazy(() =>
	import(/* webpackChunkName: "route-add-transactions" */ "containers/Transactions/addTransactions/tax")
)
export const LazyTransactionsForEpr = lazy(() =>
	import(/* webpackChunkName: "route-transactions-epr" */ "containers/Transactions/epr")
)
export const LazyAddTransactionsForEpr = lazy(() =>
	import(/* webpackChunkName: "route-add-transactions-epr" */ "containers/Transactions/addTransactions/epr")
)
export const LazyOrderRegistration = lazy(() =>
	import(/* webpackChunkName: "route-order-registration" */ "containers/VatRegistration/OrderRegistration")
)
export const LazyDac7Report = lazy(() =>
	import(/* webpackChunkName: "route-dac7" */ "containers/Dac7")
)
export const LazyReport1099 = lazy(() =>
	import(/* webpackChunkName: "route-1099" */ "containers/1099")
)
export const LazyDocuments = lazy(() =>
	import(/* webpackChunkName: "route-documents" */ "containers/Documents")
)
export const LazyDocumentTemplate = lazy(() =>
	import(/* webpackChunkName: "route-document-template" */ "containers/DocumentTemplate/DocumentTemplate")
)
export const LazyClients = lazy(() =>
	import(/* webpackChunkName: "route-clients" */ "containers/Clients")
)
export const LazyAddClient = lazy(() =>
	import(/* webpackChunkName: "route-add-client" */ "containers/AddClient/AddClient")
)
export const LazyTaxSettings = lazy(() =>
	import(/* webpackChunkName: "route-tax-settings" */ "containers/TaxSettings/TaxSettings")
)
export const LazySubscription = lazy(() =>
	import(/* webpackChunkName: "route-subscription" */ "containers/Subscription")
)
export const LazyCheckout = lazy(() =>
	import(/* webpackChunkName: "route-checkout" */ "containers/Subscription/RebuildSubsNewDesign/Checkout/Checkout")
)
export const LazyAddons = lazy(() =>
	import(/* webpackChunkName: "route-addons" */ "containers/Addons")
)
export const LazyNews = lazy(() =>
	import(/* webpackChunkName: "route-news" */ "containers/News")
)
export const LazyNewsItem = lazy(() =>
	import(/* webpackChunkName: "route-news-item" */ "containers/News/NewsItem/NewsItem")
)
export const LazyAddNewsItem = lazy(() =>
	import(/* webpackChunkName: "route-add-news" */ "containers/News/AddNewsItem/AddNewsItem")
)
export const LazyDueDates = lazy(() =>
	import(/* webpackChunkName: "route-due-dates" */ "containers/DueDates")
)
export const LazyThreshold = lazy(() =>
	import(/* webpackChunkName: "route-threshold" */ "containers/Threshold/Threshold")
)
export const LazyEPRReporting = lazy(() =>
	import(/* webpackChunkName: "route-epr-reporting" */ "containers/EPRReporting")
)
export const LazyAddEPRReporting = lazy(() =>
	import(/* webpackChunkName: "route-epr-add" */ "containers/EPRReporting/AddEPRReporting")
)
export const LazyProductsPageMain = lazy(() =>
	import(
		/* webpackChunkName: "route-authorize-products" */ "L`AuthorizeProject/ProductsPage/ProductsPageMain"
	)
)
export const LazyDigitalComplianceLabelPage = lazy(() =>
	import(
		/* webpackChunkName: "route-authorize-digital-label" */ "L`AuthorizeProject/ProductsPage/components/DigitalComplianceLabelPage/DigitalComplianceLabelPage"
	)
)
export const LazyEDocuments = lazy(() =>
	import(/* webpackChunkName: "route-e-documents" */ "EinvoiceProject/E-Documents/EDocuments")
)
export const LazyCustomers = lazy(() =>
	import(/* webpackChunkName: "route-customers" */ "EinvoiceProject/Customers/Customers")
)
export const LazyAddCustomer = lazy(() =>
	import(/* webpackChunkName: "route-add-customer" */ "EinvoiceProject/Customers/AddCustomer")
)
export const LazyLookUp = lazy(() =>
	import(/* webpackChunkName: "route-lookup" */ "EinvoiceProject/LookUp/LookUp")
)
export const LazyInvoiceReportsPage = lazy(() =>
	import(/* webpackChunkName: "route-invoice-reports" */ "EinvoiceProject/Reports/InvoiceReportsPage")
)
export const LazyEinvoiceSettings = lazy(() =>
	import(/* webpackChunkName: "route-einvoice-settings" */ "EinvoiceProject/Settings/Settings")
)
export const LazyCountryProducts = lazy(() =>
	import(
		/* webpackChunkName: "route-country-products" */ "EinvoiceProject/Settings/CountrySpecifics/CountryProducts"
	)
)
export const LazyInvoiceCreateV2Page = lazy(() =>
	import(/* webpackChunkName: "route-invoice-v2" */ "EinvoiceProject/Documents/InvoiceCreateV2Page")
)
export const LazyAddExemption = lazy(() =>
	import(
		/* webpackChunkName: "route-add-exemption" */ "containers/Documents/ExemptionCertificates/AddExemption/AddExemption"
	)
)
export const LazyCreateExemption = lazy(() =>
	import(
		/* webpackChunkName: "route-create-exemption" */ "containers/Documents/ExemptionCertificates/CreateExemption/CreateExemption"
	)
)

/** Core routes (shared across projects) — Billing, Help, Settings, Profile, Messages */
export const LazyProfile = lazy(() =>
	import(/* webpackChunkName: "route-core-profile" */ "containers/Profile")
)
export const LazyBilling = lazy(() =>
	import(/* webpackChunkName: "route-core-billing" */ "containers/Billing")
)
export const LazyAddPayment = lazy(() =>
	import(/* webpackChunkName: "route-core-add-payment" */ "containers/Billing/AddPayment")
)
export const LazyAddInvoice = lazy(() =>
	import(/* webpackChunkName: "route-core-add-invoice" */ "containers/Billing/AddInvoice")
)
export const LazyHelpCenter = lazy(() =>
	import(/* webpackChunkName: "route-core-help" */ "containers/HelpCenter/HelpCenter")
)
export const LazyDialog = lazy(() =>
	import(/* webpackChunkName: "route-core-dialog" */ "containers/Dialog/Dialog")
)
export const LazyCase = lazy(() =>
	import(/* webpackChunkName: "route-core-case" */ "containers/Case/Case")
)
export const LazyMessages = lazy(() =>
	import(/* webpackChunkName: "route-core-messages" */ "containers/Messages")
)
export const LazyMessage = lazy(() =>
	import(/* webpackChunkName: "route-core-message" */ "containers/Message")
)
export const LazyAddMessage = lazy(() =>
	import(/* webpackChunkName: "route-core-add-message" */ "containers/AddMessage")
)
export const LazyUploadDocumentsBanner = lazy(() =>
	import(/* webpackChunkName: "route-core-upload-banner" */ "containers/Messages/UploadDocumentsBanner")
)
export const LazyDocumentUploadCard = lazy(() =>
	import(/* webpackChunkName: "route-core-upload-card" */ "containers/Messages/UploadCard")
)
export const LazyPersonalSettingsPage = lazy(() =>
	import(
		/* webpackChunkName: "route-core-personal-settings" */ "containers/PersonalSettingsPage/PersonalSettingsPage"
	)
)
export const LazyBusinessSettingsPage = lazy(() =>
	import(
		/* webpackChunkName: "route-core-business-settings" */ "containers/BusinessSettingsPage/BusinessSettingsPage"
	)
)
export const LazyGlobalSettingsPage = lazy(() =>
	import(
		/* webpackChunkName: "route-core-global-settings" */ "containers/GlobalSettingsPage/GlobalSettingsPage"
	)
)
export const LazyNotificationCenter = lazy(() =>
	import(
		/* webpackChunkName: "route-core-notification-center" */ "containers/NotificationCenter/NotificationCenter"
	)
)
export const LazyProductSettingsPage = lazy(() =>
	import(
		/* webpackChunkName: "route-core-product-settings" */ "containers/ProductSettingsPage/ProductSettingsPage"
	)
)
export const LazySSOTestComplete = lazy(() =>
	import(/* webpackChunkName: "route-core-sso-complete" */ "components/SSO/SSOTestComplete")
)
